<script setup lang="ts">
withDefaults(defineProps<{ status: string; disableTransitions?: boolean }>(), {
  disableTransitions: true,
})
</script>

<template>
  <el-tag
    :disable-transitions="disableTransitions"
    :class="
      // @ts-ignore
      status.toLowerCase().replaceAll(' ', '-')
    "
    >{{ status }}</el-tag
  >
</template>

<style scoped>
.el-tag {
  padding: var(--spacing-spacing-xs);
  border-radius: var(--spacing-spacing-2xl);
}

.high,
.sent,
.used,
.present,
.under-review,
.ready-to-ship,
.in-progress,
.pending-review,
.pending {
  color: var(--text-badge-manz);
  border-color: var(--component-stroke-manz);
  background-color: var(--component-fill-manz);
}

.approved {
  color: var(--text-badge-sprout);
  border-color: var(--component-stroke-sprout);
  background-color: var(--component-fill-sprout);
}

.urgent,
.payment-late,
.expired,
.broken,
.dead-on-arrival,
.rejected,
.delinquent,
.denied,
.cancelled,
.suspended,
.terminated {
  color: var(--text-badge-orange);
  border-color: var(--component-stroke-orange);
  background-color: var(--component-fill-orange);
}

.paid,
.in-stock,
.delivered,
.assigned,
.picked-up,
.complete,
.completed,
.active {
  color: var(--text-badge-emerald);
  border-color: var(--component-stroke-emerald);
  background-color: var(--component-fill-emerald);
}

.low,
.building,
.unknown,
.created,
.inactive {
  color: var(--text-badge-gray);
  border-color: var(--component-stroke-gray);
  background-color: var(--component-fill-gray);
}

.medium,
.ready-for-billing,
.unauthorized,
.in-transit {
  color: var(--text-badge-jordy-blue);
  border-color: var(--component-stroke-jordy-blue);
  background-color: var(--component-fill-jordy-blue);
}
</style>
